import A11yDialog from 'a11y-dialog';
import Cookies from 'js-cookie';
import isbot from 'isbot';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dialog-container').forEach(el => {

    const noticeId = el.getAttribute('id');
    const expiresDays = el.getAttribute('data-expires') ? parseFloat(el.getAttribute('data-expires')) : 1;
    // const expiresDays = expiresHours / 24;
    const dialog = new A11yDialog(el, document.getElementById('main'));

    function init() {
      if (!isbot(navigator.userAgent)) {
        if (Cookies.get(noticeId) == undefined) {
          dialog.show();
          // Cookies.set(noticeId, 1, { expires: expiresDays });
        }
      }
    }

    init();
    
    dialog.on('hide', function (element, event) {
      let cookieName = element.getAttribute('id');
      let expiresDays = el.getAttribute('data-expires') ? parseFloat(el.getAttribute('data-expires')) : 1;
      Cookies.set(cookieName, 1, { expires: expiresDays });
    })

    // Add any event handlers here...
    // See https://github.com/edenspiekermann/a11y-dialog#js-api
  });
});


document.querySelectorAll('[data-action="setDefaultSite"]').forEach(el => {
  
  el.addEventListener('click', () => {
    
    // set default site cookie
    let siteGroup = el.getAttribute('data-handle');
    let cookieValue = el.getAttribute('data-id');
    Cookies.set(siteGroup + '_default', cookieValue, { expires: 7 });
    // Cookies.set(siteGroup + '_auto', 1, { expires: 90 });
    
    // remove old notices
    Cookies.remove(siteGroup + '_locNotice_' + cookieValue, { path: '/', domain: window.location.hostname });
    Cookies.remove(siteGroup + '_locNoticeSw_' + cookieValue, { path: '/', domain: window.location.hostname });
    Cookies.remove(siteGroup + '_locNoticeAw_' + cookieValue, { path: '/', domain: window.location.hostname });
    
  });
  
});